interface HashPath {
  path: string
  hash: string | null
}

export const getHashPath = (path: string): HashPath => {
  const [cleanPath, hashStart] = path.split("#")

  if (hashStart) {
    const [hash] = hashStart.split("?")
    return { path: cleanPath, hash }
  }
  return { path: cleanPath, hash: null }
}
